// Local Deps
import { displayAssociations } from '../../../../components/Billsby/plans';
import msgs from '../../../../config/messages';

export const configureInfoDetails = EntityDetailprops => {
  const { cage, organization } = EntityDetailprops;

  // const indAssSel = organization.industryAssociations ? organization.industryAssociations.length > 0 ? `${organization.industryAssociations.join(" Member, ")} Member` : "" : "";
  const indAssSel = displayAssociations(organization.associationValidations);
  const indTypesSel = organization.industryType ? organization.industryType.join(", ") : "";
  const naicsCodesSel = organization.naics ? organization.naics.join(", ") : "";

  return [
    {
      left: msgs.OrganizationForm.cageCode,
      right: cage,
    },
    {
      left: msgs.OrganizationForm.industryType,
      right: indTypesSel,
    },
    {
      left: msgs.OrganizationForm.organizationName,
      right: organization.name,
    },

    {
      left: msgs.OrganizationForm.address1,
      right: organization.address1,
    },
    ...organization.address2 ? [{
      left: msgs.OrganizationForm.address2,
      right: organization.address2,
    }] : [],


    {
      left: msgs.OrganizationForm.city,
      right: organization.city,
    },
    {
      left: msgs.OrganizationForm.state,
      right: organization.state,
    },
    {
      left: msgs.OrganizationForm.zipcode,
      right: organization.zipCode,
    },
    {
      left: msgs.OrganizationForm.country,
      right: organization.cntry,
    },
    {
      left: msgs.OrganizationForm.websiteUrl,
      right: organization.websiteUrl,
    },
    {
      left: msgs.OrganizationForm.naics,
      right: naicsCodesSel,
    },
    {
      left: msgs.OrganizationForm.industryAssociations,
      right: indAssSel,
    },

  ];
};
export const configureUserDetails = EntityDetailprops => {
  const { name, email, phone, orgAdmin } = EntityDetailprops;

  return [
    {
      left: 'Full Name',
      right: name,
    },

    {
      left: 'Phone Number',
      right: phone,
    },

    {
      left: 'Email Address',
      right: email,
    },
    // {
    //   left: 'User Type',
    //   right: orgType === 'common' ? 'Industry' : orgType,
    // },
    {
      left: 'Requested Permissions',
      right: orgAdmin,
    },
  ];
};



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/Summary/OrgtableConfig.jsx